/* DS Quick View — fetches server-rendered content via the Section Rendering API
   (same Liquid the PDP uses, so metafields/inventory/options are byte-accurate).
   Add to Cart reuses the existing global .ds-product__atc handler in cart-drawer.js —
   no separate cart logic here. */
(function () {
  if (window.__dsQuickViewInit) return;
  window.__dsQuickViewInit = true;

  var SECTION_ID = 'ds-quick-view-content';
  var cache = {};
  var lastTrigger = null;
  var modal, body;

  function moneyFormat(cents) {
    var format = window.dsMoneyFormat || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    var noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function ensureModal() {
    if (modal) return modal;
    modal = document.querySelector('[data-ds-qv]');
    body = modal ? modal.querySelector('[data-ds-qv-body]') : null;
    return modal;
  }

  function findVariantByOptions(variants, selected) {
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    });
  }

  function updateVariantDisplay(variant) {
    if (!variant) return;

    var priceWrap = body.querySelector('[data-ds-qv-price]');
    if (priceWrap) {
      if (variant.compare_at_price > variant.price) {
        priceWrap.innerHTML =
          '<span class="ds-qv__price ds-qv__price--sale">' + moneyFormat(variant.price) + '</span>' +
          '<span class="ds-qv__compare">' + moneyFormat(variant.compare_at_price) + '</span>' +
          '<span class="ds-qv__save">Save ' + moneyFormat(variant.compare_at_price - variant.price) + '</span>';
      } else {
        priceWrap.innerHTML = '<span class="ds-qv__price">' + moneyFormat(variant.price) + '</span>';
      }
    }

    var stockWrap = body.querySelector('[data-ds-qv-stock]');
    if (stockWrap) {
      if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0) {
        if (variant.inventory_quantity <= 20) {
          stockWrap.innerHTML = '<div class="ds-qv__stock ds-qv__stock--low"><span class="ds-qv__stock-dot"></span>Only <strong>' + variant.inventory_quantity + '</strong> left in stock — order soon</div>';
        } else {
          stockWrap.innerHTML = '<div class="ds-qv__stock ds-qv__stock--in"><span class="ds-qv__stock-dot"></span>In stock</div>';
        }
      } else {
        stockWrap.innerHTML = '<div class="ds-qv__stock ds-qv__stock--out"><span class="ds-qv__stock-dot"></span>Currently out of stock</div>';
      }
    }

    var atc = body.querySelector('.ds-qv__atc');
    if (atc) {
      atc.dataset.variantId = variant.id;
      if (variant.available) {
        atc.disabled = false;
        atc.textContent = 'Add to Cart — ' + moneyFormat(variant.price);
      } else {
        atc.disabled = true;
        atc.textContent = 'Out of Stock';
      }
    }

    if (variant.featured_image) {
      var mainImg = body.querySelector('[data-ds-qv-main-img]');
      if (mainImg) mainImg.src = variant.featured_image + (variant.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=800';
    }
  }

  function wireVariantSwitching() {
    var variantsScript = body.querySelector('[data-ds-qv-variants]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var selected = [];
    body.querySelectorAll('.ds-qv__option').forEach(function (block) {
      var activePill = block.querySelector('.ds-qv__pill.is-selected');
      if (!activePill) return;
      var pos = parseInt(activePill.dataset.optionPosition, 10) - 1;
      selected[pos] = activePill.dataset.optionValue;
    });

    body.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-ds-qv-opt]');
      if (!pill) return;
      var pos = parseInt(pill.dataset.optionPosition, 10) - 1;
      selected[pos] = pill.dataset.optionValue;

      pill.closest('.ds-qv__option-values').querySelectorAll('.ds-qv__pill').forEach(function (p) {
        p.classList.remove('is-selected');
      });
      pill.classList.add('is-selected');

      updateVariantDisplay(findVariantByOptions(variants, selected));
    });
  }

  function wireThumbs() {
    body.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-ds-qv-thumb]');
      if (!thumb) return;
      var mainImg = body.querySelector('[data-ds-qv-main-img]');
      if (mainImg) mainImg.src = thumb.dataset.src;
      body.querySelectorAll('.ds-qv__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  }

  function open(handle, trigger) {
    if (!ensureModal()) return;
    lastTrigger = trigger;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    body.innerHTML = '<div class="ds-qv__skeleton">Loading…</div>';
    modal.querySelector('[data-ds-qv-close]').focus();

    var fetchPromise = cache[handle] || fetch('/products/' + handle + '?section_id=' + SECTION_ID)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var wrapperId = 'shopify-section-' + SECTION_ID;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrapper = doc.getElementById(wrapperId) || doc.body;
        return wrapper.innerHTML;
      });
    cache[handle] = fetchPromise;

    fetchPromise.then(function (html) {
      if (modal.hidden) return;
      body.innerHTML = html;
      wireVariantSwitching();
      wireThumbs();
    }).catch(function () {
      body.innerHTML = '<div class="ds-qv__skeleton">Sorry, this item couldn\'t be loaded.</div>';
    });
  }

  function close() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ds-qv-trigger]');
    if (trigger) {
      e.preventDefault();
      open(trigger.dataset.handle, trigger);
      return;
    }
    if (e.target.closest('[data-ds-qv-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) close();
  });
})();
